import React, { memo } from 'react';
import Div from '../Div';
import Image from '@/shared/Image';
import { parseMediaFromCMS } from '@/utils/image';
import Heading from '../Heading';
import Paragraph from '../Paragraph';

type FeatureCardProps = {
  title?: string;
  description?: string;
  img?: string;
};

function FeatureCard({ title, description, img }: FeatureCardProps) {
  return (
    <Div className="w-44 md:w-1/3 rounded-cm flex flex-col">
      <Div className="w-44 md:w-full">
        <Image
          alt={'Feature Card Image'}
          src={parseMediaFromCMS(img).src}
          // placeholder="blur"
          blurDataURL={parseMediaFromCMS(img).src}
          className="object-cover h-auto  w-full rounded-tl-cm rounded-tr-cm"
          width={176}
          height={152}
        />
      </Div>
      <Div className="pt-s4 pb-s5 md:py-s6 bg-cti-primary px-s5 rounded-bl-cm rounded-br-cm text-cti-on-primary flex-grow">
        <Heading level={3} className="text-callout-small md:text-hd-4 ">
          {title}
        </Heading>
        <Paragraph className="text-body-sm md:text-body-md  mt-s2">{description}</Paragraph>
      </Div>
    </Div>
  );
}

export default memo(FeatureCard);
